var refreshCart, cartLoadedCallback;
$(function() { 

  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  }; 

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  
    searchAutocomplete.init();
  
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();


  productPage.initializeQuantityBox();
  productPage.init();
  productPage.loadProductRecommendations();

  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 798) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });

  
    quickShop.init();
  

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  // slider block slider
  $('.slider-block').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    prevNextButtons: false,
    lazyLoad: 2
  });

  const mobileBreakpoint = 860;
  const carouselElement = document.querySelector('.slider-block-mobile');

  function initMobileOnlySlider() {
    if (document.body.getBoundingClientRect().width <= mobileBreakpoint) {
      const flkty = new Flickity(carouselElement, { pageDots: true, imagesLoaded: true,prevNextButtons: false });
    }
  }

  initMobileOnlySlider(); // Call the function initially
  
  // new product slider
  var value_props = $('.value-props-slider').flickity({
      draggable: true,
      wrapAround:true,
      pageDots: usePageDots,
      groupCells: false,
      groupCells: 1,
      ImagesLoaded : true,
      setGallerySize : false 
    });
  
  $('[data-fancybox="props"]').fancybox({
    touch: {
      vertical : false,
      momentum : false
    }
  });
  
  $('[data-fancybox="fitguide"]').fancybox({
    beforeShow: function(){
        $("body").addClass('blocked-scroll');
    },
    afterClose: function(){
        $("body").removeClass('blocked-scroll');
    },
    touch: {
      vertical : false,
      momentum : false
    }
  });
  
  
  $('.value-props-icon a').on('click', function(){
  	value_props.flickity('select',$(this).data('fs'),0,0);
  });


  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  

  //Terms of service settings for minicart
  

  


  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  

  
    enableInfiniteScroll();
  

  

  
    enableInfiniteSearchScroll();
  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent, id) {
    var data = {};
    data.quantity = quantity;
    if(id){
      data.id = id;
    } else {
      data.line = lineID;
    }
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (data) {
        refreshCart(data);

        if(lineID){
          var lineIDIndex = lineID - 1;

          //check to see if there are correct amount of products in array
          if (typeof data.items[lineIDIndex] === "undefined"){
            var updated_quantity = 0;
          } else {
            var updated_quantity = data.items[lineIDIndex].quantity;
          }

          if(quantity > 0 && quantity != updated_quantity) {
            if (updated_quantity == 1) {
              items_left_text = "item left";
            } else {
              items_left_text = "items left";
            }

            $('.warning--quantity').remove();

            var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
            parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
            parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
          }
        }
        $("#cart_form").submit();
      }
    });
  }

  cartLoadedCallback = (cart)=> {
    refreshCart(cart);
    if($('body').hasClass('fancybox-active')) {
      $.fancybox.close();
    }
    setTimeout(function() {      

      if($('#header').is(':visible')) {
        $('#header .cart_container').addClass('active_link');
      } else if ($('.sticky_nav--stick').length) {
        $('.sticky_nav .cart_container').addClass('active_link');
      } else {
        $('.top_bar .cart_container').addClass('active_link');
      }

      //block scrolling on mobile
      if ($(window).width() <= 798) {
        var $cart_container = $(this).parent();
        if($cart_container.hasClass('active_link')) {
          $('body').addClass('blocked-scroll');
        } else {
          $('body').addClass('blocked-scroll');
        }
      }
    }, 500)
  }

  refreshCart = function (cart, show_cart = false) {
    
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;
    var cart_count = 0;
    var bundle_image_url = "//www.explorethousand.com/cdn/shop/files/bundle_1.png?v=10487992357235335197";
    
    if ( cart.item_count == 0 ) {
      
      	$('.complete-kit-sec').html('');
      	
      	$('.js-empty-cart__message').removeClass('hidden');
      	$('.js-cart_content__form').addClass('hidden');
      
      	// force cart to not open if empty
      	$('body').removeClass('is-active').removeClass('blocked-scroll');
      	$('.cart_container').removeClass('active_link');
      
       // add and remove the classes that needs to be done when the cart element is empty 
        $('.tm-hide-on-scroll').removeClass('tm-hide-on-cartopen');
        $('.thousand-cart .cart_content').addClass('empty-cart');
        $('.cart_content').hide();
        $('body').removeClass('cart-background');
      
        $cartBtn.text( cart_count );
       
    } else {
      
      	$('.thousand-cart .cart_content').removeClass('empty-cart');
      	$('.js-empty-cart__message').addClass('hidden');
      	$('.js-cart_content__form').removeClass('hidden');
      
      	var mips_col = false;
      	var bike_col = false;
      	var h2_col = false;
      	var kids_col = false;
      
      	var glove = false;
      	var sticker = false;
      	var bells = false;
      	var visors = false;
      	var light = false;
      	var kids_sticker = false;
     	var kids_bell = false;
      
      	var visor = true;
      	var monogram = true;
      	var monogram_kid = true;
      
      
      	$.each( cart.items, function( index, item ) {
          	if( item.handle == "chapter-visors" ) {
                visor = false;
            } else if ( item.handle == "monogram" ) {
                monogram = false;
            } else if ( item.handle == "thousand-jr-monogram" ){
            	monogram_kid = false;
            }
        });
      
      	var pathname = window.location.pathname; // Returns path only (/path/example.html)
      
      	var bundle_product = false;
        var bundle_products_data = {};

      	$.each( cart.items, function( index, item ) {
          
          if( item.properties != null && item.properties._btype != null ) {
            	
            	bundle_product = true;	
            	bundle_products_data[item.properties._btype] = ( typeof bundle_products_data[item.properties._btype] == 'undefined' ) ? [] : bundle_products_data[item.properties._btype];
            	if( item.handle == 'monogram' || item.handle == "thousand-jr-monogram"  ) {
            		bundle_products_data[item.properties._btype].push({ 'initials': item.properties.Initials, 'helmet': item.properties.Helmet, 'name' : item.title, 'price' : item.price, 'varient_id' : item.variant_id, 'discounted_price' : item.discounted_price  });
                }else {
                    bundle_products_data[item.properties._btype].push({ 'name' : item.title, 'price' : item.price, 'varient_id' : item.variant_id , 'discounted_price' : item.discounted_price });
                }
                
          } else {
            
            cart_count += parseInt( item.quantity );
          
        	var discountMessage = "";
        	if( typeof item.discounts != 'undefined' ) {	
              var itemDiscounts = item.discounts;
              for (i=0; i < itemDiscounts.length; i++) {
                  	var amount = formatMoneyStripTrailingZeros(itemDiscounts[i].amount, $('body').data('money-format'));
                	var title = itemDiscounts[i].title;
                	discountMessage = '<p class="notification-discount meta"><span style="font-weight:bold"> Discount :</span> ' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
              }
            }
        
            var line_id = index + 1;
            cart_items_html += '<li class="cart_item cart_item-type__' + handleize(item.product_type) + ' cart_item__' + handleize(item.product_title) + ' clearfix">' +
              '<a href="' + item.url +'">';
            if (item.image) {
              cart_items_html += '<div class="cart_image">' +
                  '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                '</div>';
            }
            
        	cart_items_html += '<div class="cart_item__title" data-variant="' + item.variant_title + '" data-key="' + item.key + '"><div class="item_title">' + item.title;

            if( item.properties ) {
              $.each( item.properties, function( title, value ) {
                // TODO refine this. only specific line items related to monogram should be shown
                if (title === 'monogram') {
                  cart_items_html += '<div class="line-item line-item--' + handleize(title) + '"><span class="line-item__title">' + title +': </span><span class="line-item__value">' + value + '</span></div>';
                }
              });
            }
            
            if ( item.price > item.final_price ) {
              cart_items_html += '</div>' + discountMessage + '</a>';
            } else {
              cart_items_html += '</div></a>'
            }
          
          	cart_items_html += '<div class="ths-customizer-option">';
            
          	if( item.handle == "mips-helmet" ) {
                mips_col = true;
              	if( visor ) {
                  	var ga_event ="ga('send', 'event', {transport: 'beacon', eventCategory: 'Visor', eventAction: 'Clicked Upsell'})";
                	cart_items_html += '<p class="upsell-copy"><a href="/products/chapter-visors" onclick="'+ga_event+'"><span class="upsell-img"><img src="//cdn.shopify.com/s/files/1/0836/6919/files/visor-img_1024x768.png?v=6739104187907497265"></span><span class="upsell-text">Add a Visor ></span></a></p>';
              	}
            } else if ( item.handle == "bike-helmet" ) {
                bike_col = true;
             	  if( monogram ) {
                  	if(pathname.indexOf('bike-helmet') != -1){
                    	var monogram_variant = $.grep($('.product_form_options ').data('product').variants, function(v) {
                      		if(v.id == item.variant_id){
                          		return v;
                      		}
                  		});
                
    			  		
                    }
                 }
            } else if ( item.handle == "bike-helmet-2" ) {
                h2_col = true;
             	  if( monogram ) {
                  	if(pathname.indexOf('bike-helmet-2') != -1){
                    	var monogram_variant = $.grep($('.product_form_options ').data('product').variants, function(v) {
                      		if(v.id == item.variant_id){
                          		return v;
                      		}
                  		});
                
    			  		
                    }
                 }
            } else if ( item.handle == "kids-helmet" ) {
                kids_col = true;
             	if( monogram_kid ) {
                 if(pathname.indexOf('bike-helmet') != -1){
                  	var monogram_kid_variant = $.grep($('.product_form_options ').data('product').variants, function(v) {
                        if(v.id == item.variant_id){
                            return v;
                        }
                    });
                    
    					
                    }                
                }
            }else if ( item.handle == "helmet-stickers" ) {
              	sticker = true
            }else if ( item.handle == "bike-bell" ) {
              	bells = true
            }else if ( item.handle == "bike-gloves" ) {
              	glove = true
            }else if ( item.handle == "chapter-visors" ) {
              	visors = true
            }else if ( item.handle == "bicycle-light" ) {
              	light = true
            }else if ( item.handle == "kids-stickers" ) {
              	kids_sticker = true
            }else if ( item.handle == "kids-bell" ) {
             	kids_bell = true
            }
          
          	cart_items_html  += '</div>';
          

            cart_items_html += '<div class="left product-quantity-box">' +
                '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
                '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
                '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
              '</div>' +
            '</div>';

        	cart_items_html += '<strong class="right price">';
        	
          	var tm_final_price =false;
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                url: "/products/" + item.handle + ".js",
                success: function(data) {
                  var variant_id = item.variant_id;
                  var variant = $.grep(data.variants, function(v) {
                        return v.id == variant_id;
                  });
                  if(variant[0] && variant[0].compare_at_price > item.price) {
//                         discounted_price_total += item.price * item.quantity;
//                         total_savings += variant[0].compare_at_price * item.quantity;
                    tm_final_price = variant[0].compare_at_price;
                  }
                }
              });
          
            if ( tm_final_price) {
               //puts the slash through the old item price
               var itemPrice = formatMoneyStripTrailingZeros(item.final_price, $('body').data('money-format')) + '</span><span class="money was_price">' + formatMoneyStripTrailingZeros(tm_final_price, $('body').data('money-format')) + '</span>';
               cart_items_html += '<span class="money">' + itemPrice + '</strong></div></a></li>';
            } else {
                var itemPrice = formatMoneyStripTrailingZeros(item.discounted_price, $('body').data('money-format')) + '</span>';
              	if ( item.price != item.discounted_price  ) {
                  	itemPrice += '<span class="money was_price">' + formatMoneyStripTrailingZeros(item.price, $('body').data('money-format')) + '</span>';
              	}
             	cart_items_html += '<span class="money">' + itemPrice + '</strong></div></a></li>';
            }
            
          }
          
      	});
      
      
      	if( bundle_product ) {
          
          	$.each( bundle_products_data, function( key, bproduct ){
              	cart_count += parseInt(1);
              	var bprice = 0;
              	var dprice = 0;
              	var products_ids = [];
              	cart_items_html += '<li class="cart_item cart_item-type__helmet clearfix">';
                cart_items_html += '<a href="'+kit_page_url+'">';
                cart_items_html += '<div class="cart_image"><img src="'+bundle_image_url+'" alt="" class=" lazyloaded"></div>';
                cart_items_html += '</a>';
                cart_items_html += '<div class="cart_item__title" data-variant="" data-key="">';
                cart_items_html += '<div class="item_title"> Helmet Bundle </div>';
				cart_items_html += '<ul>';	
              
              	var array_reverse = bproduct.reverse();
              	array_reverse.forEach( function ( sproduct, index ) {
                  	products_ids.push(sproduct.varient_id)
                  	bprice += sproduct.price;
                  	dprice += sproduct.discounted_price;
                  	var ptitle = ( typeof sproduct.initials != 'undefined' ) ?  sproduct.name + ' / ' + sproduct.initials  : sproduct.name;
                  	cart_items_html += '<li><strong>' + ptitle + '</strong></li>';	
                });
              	
                cart_items_html += '</ul>';
              	cart_items_html += '<div class="edit_bundle"><a href="'+kit_page_url+'?btype='+key+'" >Edit bundle</a></div>';
              	cart_items_html += '<div data-page="other" data-ids="'+ products_ids +'" data-bundle="'+key+'" class="delete_bundle"><a href="#">Delete bundle</a></div>';
                cart_items_html += '</div>';

                cart_items_html += '<strong class="right price" style="padding-left: 5%;">';
              	var bundle_price_html = formatMoneyStripTrailingZeros(dprice, $('body').data('money-format')) + '</span>';
              	if ( bprice != dprice  ) {
                  	bundle_price_html += '<span class="money was_price">' + formatMoneyStripTrailingZeros(bprice, $('body').data('money-format')) + '</span>';
              	}
              	cart_items_html += '<span class="money">' + bundle_price_html + '</strong></div></a></li>';
              	cart_items_html += '</strong>';

                cart_items_html += '</li>';
              
			});

      	}
      
      	$cartBtn.text( cart_count );
      
      
      	// insert complete your kit html ..
      	window.scrollTo(0, 0);
      	addCompleteYourOrder( mips_col, bike_col, kids_col, glove, sticker, bells, visors, light, kids_sticker, kids_bell, show_cart, h2_col );
      	
      	if (!show_cart ) {
        	jQuery('body').addClass('cart-background');
        	jQuery('.cart_container').addClass('active_link');
      		jQuery('.cart_container .cart_content').show();
     	}
      
      
      	var cartDiscountMessage = "";
        if( typeof cart.cart_level_discount_applications != 'undefined' ) {
          var cartDiscounts = cart.cart_level_discount_applications;
          for (i=0; i < cartDiscounts.length; i++) {
              var amount = formatMoneyStripTrailingZeros(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
              var title = cartDiscounts[i].title;
              cartDiscountMessage = '<p class="mm-counter price">' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
          }
          if (cart.cart_level_discount_applications.length > 0) {
              cart_discounts_html += '<span class="right">' + cartDiscountMessage + '</span><span>Discount</span>'
          }
        }

      	cart_action_html += '<span class="right"><span class="money">' + formatMoneyStripTrailingZeros(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Subtotal</span>';

        if(total_savings > 0 ) {
          cart_savings_html = '<span class="right"><span class="money">' + formatMoneyStripTrailingZeros(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
              '<span>Total Savings</span>';
        } else {
          cart_savings_html = "";
        }
    }
    
    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_discounts').html(cart_discounts_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

    
    
  }
  
  
$(document).ready(function(){
  $.ajax({
       url: '/cart.js',
       dataType: "json",
       cache: false,
       success: function( cart ) {
         // Fix: ensure cart currency matches active storefront currency on first load
         var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
         if (activeCurrency && cart.currency !== activeCurrency) {
           $.ajax({
             url: '/cart/update.js',
             type: 'POST',
             dataType: 'json',
             data: { currency: activeCurrency },
             success: function(updatedCart) {
               refreshCart(updatedCart, true);
             }
           });
         } else {
           refreshCart(cart, true);
         }
       }
  });
});
  
  
   $('body').on('click', '.delete_bundle', function() {
      	var ids = $(this).data('ids');
     	
     	var page = $(this).data('page')
     	
     
     	removeBundleItems( ids, page );
   });
  
  
  function removeBundleItems(items, page) {
    var qty = 0;
    var data = { updates: {} };
    if( typeof items == 'number' ) {
      data.updates[items] = qty;
    } else {
      	var itemsArray = items.split(',');
      	for (i = 0; i < itemsArray.length; i++) {
        	data.updates[itemsArray[i]] = qty;
      	}
    }
   
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() { 
		
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function( cart ) {
              if( page == 'cart' ) {
                location.reload();
              }else {
                refreshCart( cart );
              }
            }
         })
      }
    });
}
 
  
  
  $('body').on('click', '#cart_form .js-change-quantity, .cart_content .js-change-quantity', function() {
    if($(this).data('func') === 'minus') {
      handleConnectedProductsRemoval(this);
    } else {
      $(document).trigger('thousand:beforeUpdateCart', this);
    }
  });

  $(document).on('thousand:beforeUpdateCart', function(e, el){
    ajaxUpdateCart(
      $(el).siblings('.quantity').data('line-id'), 
      $(el).siblings('.quantity').val(), 
      $(el).parents('#cart_form, .cart_content'),
      $(el).parents('.cart_item__title').data('key')
    );
  });

  
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();
      if($('.monogram-checkbox')[0] && $('.monogram-checkbox')[0].checked){
        console.log('bypassing Add to Cart');
        $(document).trigger('thousand:atcClickTriggersMonogram');
        document.querySelector('.monogram-checkbox').checked = false;
        return;
      }
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled is--sending');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          $(document).trigger('thousand:addedToCart', itemData);
          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');            
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: cartLoadedCallback
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  

  productPage.productSwatches();

});

/*============================================================================
  Footer returns link
==============================================================================*/

if(user_loc_country_handle === 'gb'){
	document.querySelectorAll('a[href="https://returns.explorethousand.com"]').forEach(link => {
		link.href = "https://www.explorethousand.com/apps/redo/returns-portal/login?referralId=6983978f8937ef9b143c73e5";
	});
}

/*============================================================================
  Mega Menu
==============================================================================*/

$('.mega-menu-parent').on('click', e => {
  return false;
  e.preventDefault();
})

$('.top_link').on('mouseenter', e => {
  $('.active_link').removeClass('active_link');
  $('.dropdown_container').hide();
})

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      var var_ava=variant.available;
      if($.inArray(user_loc_country,restricted_country) !== -1){
      	var_ava = false;
      }else if(inventryByLocation.hasOwnProperty(variant.id) ){
        if(inventryByLocation[variant.id][user_loc]>0){
        	var_ava = true;
        }else{
        	var_ava = false;
        }
      }
      if (var_ava) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

//Differentiate between mobile and touch screen laptops
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",formatMoneyStripTrailingZeros=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if ($parentSection.hasClass('recommended-products-section')){
      if ($('.block__recommended_products').length){
        productPage.init();
        productPage.loadProductRecommendations();
      }
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
        if($('#shopify-product-reviews').length >= 1) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    


    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    
      if ($parentSection.hasClass('search-section')){
        searchAutocomplete.init();
      }
    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
        if($('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.loadProductRecommendations();
      productPage.productSwatches();
      recentlyViewed.init();
      
        if($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      

    }

    if ($parentSection.hasClass('recommended-products-section')) {
      productPage.init();
      productPage.loadProductRecommendations();
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
        searchAutocomplete.init();
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
//       header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
      productPage.init();
      productPage.loadProductRecommendations();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

// generic smooth scroll
$('body').on('click', '[data-scroll-trigger]', function(e){
  e.preventDefault();
  $("html, body").animate({
    scrollTop: ($(e.target.dataset.scrollTo).offset().top)
  }, 500);
})

//trigger fit guide
$('body').on('click', '.size_chart', function(){
  $('.tabs li:nth-child(3) a').trigger('click');
})

 // show product name
$(document).on('thousand:variant:selected', function (e, data) {
  var $body = $('body');
  var colorOrStyle = data.option1;
  var sizeOrLocation = data.option2;
  $body.find('.current-color, .current-style').text(colorOrStyle);
  $body.find('.variant_title_change, .current-style').text(colorOrStyle);
  $body.find('.current-size, .current-location').text(sizeOrLocation);
  $body.attr('data-variant', data.option1.toLowerCase().replace(' ','-'))
  $body.attr('data-variantid', data.id)
});

/* #Cross-sell carousel module
================================================== */

var CrossSell = function(){
  var crossSellSlider;
  function init(){
    var sliderExistsTimer = setInterval(function() {
      if ($('.cross-sell').length) {
        clearInterval(sliderExistsTimer);
        // setup slider if mobile
        $(window).trigger('resize');
      }
    }, 250);            
  }

  $(window).resize(handleWindowResize);

  function handleWindowResize(){
    var crossSellSliderLoaded = $('.cross-sell').data('flickity');
    if(window.innerWidth < 768){
      if(crossSellSliderLoaded){
        crossSellSlider.flickity('resize');
      } else {
        crossSellSlider = $('.cross-sell').flickity({
          wrapAround: false,
          pageDots: false
        });
      }
    } else {
      if(crossSellSliderLoaded){
        crossSellSlider.flickity('destroy');
      }
    }
  }

  init();

};

CrossSell();

/* #Mobile carousel module - Load carousel only on mobile
================================================== */

var MobileCarousel = function(){
  var mobileCarouselSlider;
  function init(){
    var sliderExistsTimer = setInterval(function() {
      if ($('.mobile-carousel').length) {
        clearInterval(sliderExistsTimer);
        // setup slider if mobile
        $(window).trigger('resize');
      }
    }, 250);
  }

  $(window).resize(handleWindowResize);

  function handleWindowResize(){
    var mobileCarouselSliderLoaded = $('.mobile-carousel').data('flickity');
    if(window.innerWidth < 768){
      if(mobileCarouselSliderLoaded){
        mobileCarouselSlider.flickity('resize');
      } else {
        mobileCarouselSlider = $('.mobile-carousel').flickity({
          wrapAround: false,
          pageDots: false,
          adaptiveHeight: true
        });
      }
    } else {
      if(mobileCarouselSliderLoaded){
        mobileCarouselSlider.flickity('destroy');
      }
    }
  }

  init();

};

MobileCarousel();

// #Accordion module
// ================================================== //

const Accordion = ()=>{
  function init () {
    $('.js-accordion__header')
    .on('touchstart',handleAccordion)
    .on('mouseover', e=>{
      if(!$('.hidden-desktop').is(':visible')){
        handleAccordion(e);
      }
    })
  }

  function handleAccordion (e) {
    $('.js-accordion__content').removeClass('is--active');
    $(e.currentTarget).next('.js-accordion__content').addClass('is--active');
  }

  init();
}

Accordion();




// #Monogram module
// ================================================== //

  const UpsellCheckboxes = ()=> {
    const UISettings = {
      $carousel: $('.product_gallery'),
      $carouselNav: $('.product_gallery_nav'),
      get carouselFlickity() { return this.$carousel.data('flickity') },
      get carouselNavFlickity() { return this.$carouselNav.data('flickity') },
      $taillightCheckbox: $('.taillight-checkbox'),
      taillightImgIndex: 4,
      taillightImgSelector: '.gallery-cell:nth-child(5)',
      $visorCheckbox: $('.visor-checkbox'),
      $visorSelect: $('.visor-select'),
      visorCellClassname: 'visor-cell',
      $holidayCheckbox: $('.holiday-checkbox'),
      $customCheckbox: $('.custom-checkbox'),
      shopifyBaseFilePath: "//www.explorethousand.com/cdn/shop/files/?v=135609".split('?')[0],

    }

    const init = ()=> {
      bindUIEvents()
    }

    const bindUIEvents = ()=> {
      UISettings.$visorCheckbox.on('change', handleVisorCheckboxChange)
      UISettings.$taillightCheckbox.on('change', handleTaillightCheckboxChange)
      UISettings.$visorSelect.on('change', handleVisorSelectChange)
      $(document).on('thousand:variant:selected', handleVariantChange);
      $(document).on('thousand:addedToCart', handleAfterAddToCart)
    }

    const handleVisorCheckboxChange = (e)=> {
      UISettings.$visorSelect.toggleClass('hidden');
      if(!e.target.checked){
        removeVisorImg();
        resetVisorSelectOption();
      }
    }

    const handleVisorSelectChange = ()=> {
      removeVisorImg()
      if(UISettings.$visorSelect.val()){
        const visorImg = insertVisorImg();        
      }      
    }

    const insertVisorImg = ()=> {
      const currentVariantHandle = handleize(thousand.globals.currentVariantJSON.option1);
      const selectedVisorHandle = handleize(UISettings.$visorSelect.find(':selected').data('variant-title'));
      const visorImgString = `chapter-visor-${currentVariantHandle}-${selectedVisorHandle}.jpg`;
      const visorImgPath = `${UISettings.shopifyBaseFilePath}${visorImgString}`;
      const visorImgFallbackPath = `${UISettings.shopifyBaseFilePath}chapter-visor-default-${selectedVisorHandle}.jpg`;
      let visorHTML = null;
      
      // test if image loads, if not load fallback
      let visorImg = new Image();
      $(visorImg).on('load', function(){       
       visorHTML = $(`<div class="gallery-cell ${UISettings.visorCellClassname}" />`).append($(visorImg));
       onImgLoad();
      }).one('error', function(){
        $(visorImg).attr('src', visorImgFallbackPath)
        visorHTML = $(`<div class="gallery-cell ${UISettings.visorCellClassname}" />`).append($(visorImg));
        onImgLoad();
      }).attr('src', visorImgPath)

      const onImgLoad = ()=> {
        UISettings.carouselFlickity.prepend( visorHTML );
        $('html, body').animate({ scrollTop: 0 }, 500);
        UISettings.carouselFlickity.select(0);
      }
    }

    const removeVisorImg = ()=> {
      UISettings.carouselFlickity.remove($(`.${UISettings.visorCellClassname}`));
    }
    const resetVisorSelectOption = ()=> UISettings.$visorSelect.val('') 

    const handleTaillightCheckboxChange = (e)=> {
      // scroll to taillight
      if(e.target.checked){     
        //mobile only
        UISettings.carouselFlickity.select(UISettings.taillightImgIndex )
        // desktop and mobile
        $('html, body').animate({
          scrollTop: UISettings.$carousel.find(UISettings.taillightImgSelector).offset().top
        }, 500);
      }
    }

    const handleVariantChange = (variant, selector)=> {
      if(!UISettings.$visorCheckbox.is(':checked')){
        return;
      }
      setTimeout(handleVisorSelectChange, 200)
    }
    
    const handleAfterAddToCart = (e, data)=> {
      let items = [];
      if(!!data?.properties?.taillight_checked){
        items.push({ id: '41672449130543', quantity: 1 })
      }
      if(!!data?.properties?.visor_checked){
        items.push({ id: UISettings.$visorSelect.val(), quantity: 1 })
      }
      if(!!data?.properties?.holiday_checked){
        items.push({ id: UISettings.$holidayCheckbox.val(), quantity: 1 })
      }     
      if(!!data?.properties?.custom_checked){
        items.push({ id: UISettings.$customCheckbox.val(), quantity: 1 })
      }
      items && addUpsellItemsToCart(items);
    }

    const addUpsellItemsToCart = (items)=> {
      var jqxhr =  $.getJSON('/cart/add.js', {items})
        .done((data)=>{
          $.ajax({
            url: '/cart.js',
            dataType: "json",
              cache: false,
              success: function( cart ) {
                refreshCart( cart, true );
              }
          });
        })
        .fail((data)=>{});
    }
    
    return { init };
  };

  UpsellCheckboxes().init();

// #Monogram module
// ================================================== //

var Monogram = function(){

  var $doc = $(document);
  var $monogramContainer = $('.monogram__container');
  var $monogramDisplay = $('.monogram-display');
  var $monogramDisplayLetters = $('.monogram-display-letters');
  var $lettersInput = $('.builder__letters-input input');
  var $lettersError = $('.letters__error');
  var activeClass = 'active';
  var shopifyFileUrl = "//www.explorethousand.com/cdn/shop/files/?v=135609";
  var baseFilePath = shopifyFileUrl.split('?')[0];
  var maxLength = 3;
  var LengthText = '3 Letters';
  var monogramFinish = '';
  var monogramStyle = '';
  var monogramInitials = '';
  var monogramInitials = '';
  var monogramProduct = {};
  var currentHelmetProduct = {};
  var currentHelmetVariant = {};
  var defaultLetters = '';
  var stepsSlider;
  var isClickMiniCart = false;
  // fix shopify money format issue
  
  var moneyFormat = '${{amount}}';
  

  // Trigger custom events

  $('.builder__style-variant input').on('change', function(e){
    $doc.trigger('monogram:style:selected', e.target.dataset.variantInfo);
  })

  $('.builder__finish-variant input').on('change', function(e){
    $doc.trigger('monogram:finish:selected', {
      finish: e.target.dataset.variantInfo,
      price: e.target.dataset.variantPrice
    });
  })

  $lettersInput.on('input', function(e){
    var disallowedCharsRegex = /[^A-Za-z]/g;
    var isDisallowedChar = disallowedCharsRegex.test(e.target.value);
    e.target.value = e.target.value.toUpperCase().replace(disallowedCharsRegex, '');
    if(isDisallowedChar){
      displayValidation('Please use letters only');
    }  else {
      hideValidation();
    }   
    $doc.trigger('monogram:letters:selected', e.target);
  })

  // Custom event handlers

  $doc.on('monogram:style:selected', function(e, data){
    monogramStyle = data;
    $('.builder__selected-style, .monogram-title__style').text(monogramStyle);  
    $monogramDisplay.attr('data-style', handleize(monogramStyle));
    updateMonogramImage();
    defaultLetters = defaultLetters || $lettersInput.attr('placeholder');
    // clear field and set maxlength
    
    if(monogramStyle === 'Diamond'){
      maxLength = 1;
      LengthText= "1 Letter";
    } else if(monogramStyle === 'Lightning Bolt'){
      maxLength = 2;
      LengthText= "2 Letters";
    }  else if(monogramStyle === 'Sunburst'){
      maxLength = 1;
      LengthText= "1 Letter";
    } else {
      maxLength = 3;
      LengthText= "3 Letters";
    }
    var defaultInitialsSliced = defaultLetters.slice(0, maxLength);
    $lettersInput.attr('maxlength', maxLength);
    $lettersInput.attr('placeholder', defaultInitialsSliced);
    $('.builder__amount-letters').text(LengthText);
    $lettersInput.val('');
    $doc.trigger('monogram:letters:selected', { value: defaultInitialsSliced });
    hideValidation();
  })

  $doc.on('monogram:finish:selected', function(e, data){
    monogramFinish = data.finish;
    monogramPrice = data.price;
    $('.builder__selected-finish, .monogram-title__finish').text(monogramFinish);
    $('.builder-summary__monogram-price, .builder__selected-finish-price').text(formatMoneyStripTrailingZeros(monogramPrice, moneyFormat));
    $('.subtotal__number').text(formatMoneyStripTrailingZeros(parseFloat(monogramPrice) + parseFloat(currentHelmetVariant.price)));
    $monogramDisplay.attr('data-finish', handleize(monogramFinish));
    updateMonogramImage();
  })

  $doc.on('monogram:letters:selected', function(e, data){
    var monogramSpanInitials;
    if(data){
      monogramInitials = data.value;
      monogramSpanInitials = monogramInitials.replace(/(.)/g, '<span>$1</span>');
    } else {
      monogramInitials = monogramSpanInitials = data;
    }
    $('.monogram-title__letters').text(monogramInitials);
    $('.monogram-display-letters').html(monogramSpanInitials);
  })

  $('.monogram__add-to-cart').on('click', function (e) {
    e.preventDefault();
    if(!getMonogramVariant()){
      alert('variant does not exist');
      return;
    }
    
    if(isInvalid()){
      displayValidation(' - Please enter ' + (maxLength - $lettersInput.val().length) + ' more letter(s)');
      return;
    }
    if(isTooManyLetters()){
      $lettersInput.val('');
      displayValidation(' - Please enter only ' + maxLength + ' letters');
      return;
    }

    addMonogramToCart();
  })

  $('.monogram__close-btn, .monogram__close-x').on('click', unload);

//   $('.monogram__open-btn').on('click', init);
  
  $(document).on('click','.monogram__open-btn', init);
  $(document).on('thousand:atcClickTriggersMonogram', init);
  
  
  $(document).on('click','.monogram__open-btn_header', function(e){
    isClickMiniCart = true;
    currentHelmetVariant = $(this).data('variant-upsell');
    ga("send", "event", {eventCategory: "Monogram", eventAction: "Clicked Upsell"})
  	init(e);
  });

  $(document).on('thousand:variant:selected', function(e, data){
    currentHelmetVariant = data;
  });

  function init(e){
    if(e){
      e.preventDefault();
    }
    window.scrollTo(0,0);
    $monogramContainer.fadeIn(300);
    $('body').addClass('overflow-y-hidden is--monogram-open');
    var $productRequest = $.getJSON(window.location.href  + '.json');
    $productRequest.done(function(data){
      currentHelmetProduct = data.product;
      var featuredVariantPosition = currentHelmetVariant.featured_image.position;
      // get 4th variant image
      var currentVariantImage = currentHelmetProduct.images[featuredVariantPosition + 2].src;
      $('.monogram__image img').attr('src', currentVariantImage).one('load', setupMonogramUI);
      
      if($('#sunburst').length){
        $('#sunburst').attr('data-tbimg',currentHelmetVariant.option1);
      }
      var monogram_product = 'monogram';
      if(currentHelmetProduct.handle == 'kids-helmet'){
      	monogram_product = 'thousand-jr-monogram';
      }
      var $monogramRequest = $.getJSON('/products/'+monogram_product+'.js');  
      $monogramRequest.done(function(monogram){
      	monogramProduct = monogram;
      })    
    });
  }

  function setupMonogramUI(){
    $monogramContainer.removeClass('loading');
    $('.monogram__slider').removeClass('hidden');
    $('.builder__style-variant input:first, .builder__finish-variant input:first').click();
    $('.builder-summary__product-title').text(currentHelmetProduct.title + ', ' + currentHelmetVariant.title);
    $('.monogram__slider').flickity({
      wrapAround: true,
      autoPlay: 3000
    });
    // setup steps slider if mobile
    $(window).trigger('resize');    
  }    

  $('.monogram .steps__arrow').on('click', handleStepsArrowClick);

  $(window).resize(handleWindowResize.bind(this));

  function handleWindowResize(){
	// if page is for ride shop do not add flickity
    if( jQuery('#tm_kit_builder').length > 0 ) {
      	return false; 
    }
    
    // 
    var stepsSliderLoaded = $('.builder__steps').data('flickity');
    if($(this).width() < 768){
      if(stepsSliderLoaded){
        stepsSlider.flickity('resize');
      } else {
        stepsSlider = $('.builder__steps').flickity({
          wrapAround: false,
          prevNextButtons: false,
          pageDots: false
        });
      }
    } else {
      if(stepsSliderLoaded){
        stepsSlider.flickity('destroy');
      }
    }
  }

  function handleStepsArrowClick(e, that){
    var stepsSliderData = stepsSlider.data('flickity');
    var $clickedArrow = $(e.target);
    $('.steps__arrow').removeClass('hidden');
    if ($clickedArrow.is('.steps__arrow--prev')){
      stepsSlider.flickity('previous');
      if(stepsSliderData.selectedIndex < 1){
        $clickedArrow.addClass('hidden');
      }
    } else {
      if(stepsSliderData.selectedIndex === 1 && isInvalid()){
        displayValidation(' - Please enter ' + (maxLength - $lettersInput.val().length) + ' more letter(s)');
        return;
      }
      stepsSlider.flickity('next');
      if(stepsSliderData.selectedIndex === stepsSliderData.cells.length - 1){
        $clickedArrow.addClass('hidden');
      }
    }
  }

  function unload(){
    $monogramContainer.fadeOut(500);
    $('body').removeClass('overflow-y-hidden is--monogram-open blocked-scroll');
    $monogramContainer.addClass('loading');    
    $('.builder-summary__product-title').text('');
    $('.monogram__slider').flickity('destroy');
    $('.monogram__slider').addClass('hidden');
//     stepsSlider.flickity('destroy');
    $('.steps__arrow--prev').addClass('hidden');
    $('.steps__arrow--next').removeClass('hidden');
  }

  function updateMonogramImage(){ 
    $monogramDisplayLetters.attr('data-htype','');
    if(!monogramStyle || !monogramFinish){
      return;
    }

    if(monogramStyle === 'Zig Zag'){
      $monogramDisplayLetters.css('background-image', 'none');
      return;
    }
    var imgPath = baseFilePath + 'thousand-monogram-' + handleize(monogramStyle) + '-' + handleize(monogramFinish) + '.png';
    $monogramDisplayLetters.css('background-image', 'url(' + imgPath + ')');
    if(monogramStyle === 'Sunburst'){
      $monogramDisplayLetters.attr('data-htype',$('#sunburst').attr('data-tbimg'));
      return;
    }
  }

  function getMonogramVariant(){
    var monogramVariant = monogramStyle + ' / ' + monogramFinish;
    return monogramProduct.variants.find(function(o){
      return o.title === monogramVariant;
    });
  }

  function isInvalid(){
    return (
      ($lettersInput.val() === '') ||
      (monogramStyle === 'Zig Zag' && $lettersInput.val().length < 3) ||
      (monogramStyle === 'Lightning Bolt' && $lettersInput.val().length < 2)
    )
  }

  function isTooManyLetters(){
    return (
      (monogramStyle === 'Zig Zag' && $lettersInput.val().length > 3) ||
      (monogramStyle === 'Lightning Bolt' && $lettersInput.val().length > 2) ||
      (monogramStyle === 'Diamond' && $lettersInput.val().length > 1) ||
      (monogramStyle === 'Sunburst' && $lettersInput.val().length > 1)
    )
  }

  function displayValidation(errText){
    $lettersError.text(errText);
    $lettersInput.addClass('is-error').focus();
    window.scrollTo(0,0);
    if(stepsSlider && stepsSlider.data('flickity')){
      stepsSlider.flickity('selectCell', 1);
      $('.steps__arrow').removeClass('hidden');
    }    
  }

  function hideValidation(){
    $lettersError.text(''); 
    $lettersInput.removeClass('is-error');
  }

  function addMonogramToCart(id, props){
    jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  items: [
                    {
                      quantity: 1,
                      id: getMonogramVariant().id,
                      properties: {
                        "Initials": monogramInitials, 
                        "Helmet": currentHelmetVariant.title,
                        "Notice": "Item can\'t be exchanged or returned",
                      }   
                    },
                    {
                      quantity: 1,
                      id: currentHelmetVariant.id,
                    }
                  ]
                },
                dataType: 'json',
                success: function( response ) {
                  
                  $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function( cart ) {
                      setTimeout( function() {
                        $('.monogram__close-x').click();
                        refreshCart( cart );

                        
                        if(isClickMiniCart){
                          if( $('body').hasClass('fancybox-active') ) {
                            $.fancybox.close();
                          }

                          if($('#header').is(':visible')) {
                              $('#header .cart_container').addClass('active_link');
                          } else if ($('.sticky_nav--stick').length) {
                              $('.sticky_nav .cart_container').addClass('active_link');
                          } else {
                              $('.top_bar .cart_container').addClass('active_link');
                          }

                          //block scrolling on mobile
                          if ( $(window).width() <= 798 ) {
                              var $cart_container = $(this).parent();
                              if( $cart_container.hasClass('active_link') ) {
                                  $('body').addClass('blocked-scroll');
                              } else {
                                  $('body').addClass('blocked-scroll');
                              }
                          }
                        } else {
                          $('.cart_container').addClass('active_link');
                        }
                        

                      }, 500);
                    }
                  });
                                 
                }
            });
    
  }

  function handleAddMonogramToCartDone(res){
//     $('.product-copy-section:visible .purchase-details .add_to_cart').click();
//     refreshCart(res);
    $('.monogram__close-x').click();
//     window.location.reload(true);
//     window.location.reload();
//     setTimeout(function(){
//       $('.cart_container').addClass('active_link');
//     }, 1000);
  }

}();

function handleize(data){
  return data.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
}

// $('.wishes__carousel').flickity({
//   wrapAround: true
// });

function handleConnectedProductsRemoval(el) {
  var productsToRemoveObj = {};
  var $self = $(el);
  var variantTitle = $self.parents('.cart_item__title').data('variant');
  var thisCount = $(el).siblings('.quantity').val();
  if(!variantTitle){
    // not a helmet
    $(document).trigger('thousand:beforeUpdateCart', el);
    return;
  }  
  $('.cart_items .cart_item').each(function(i, item){
    var $helmetLineItem = $(this).find('.line-item--helmet .line-item__value');
    var itemQuantity = $(this).find('.quantity').val();
    var monogramAlreadyRemoved = false;
    var isMonogram = $(this).is('.cart_item__monogram');
    if($helmetLineItem && $helmetLineItem.text() === variantTitle){
      // don't remove more than 1 different monogram per helmet
      if(monogramAlreadyRemoved === true){
        return;
      }
      if(isMonogram){
        monogramAlreadyRemoved = true;
      }
      var itemKey = $(item).find('[data-key]').data('key');
      productsToRemoveObj[itemKey] = parseFloat(itemQuantity) - 1;
    }
  });  
  if(!$.isEmptyObject(productsToRemoveObj)){
    $.getJSON('/cart/update.js', {
      updates: productsToRemoveObj
    })
    .done(function(data){
      $(document).trigger('thousand:beforeUpdateCart', el);
      refreshCart(data);
    });
  } else {
    $(document).trigger('thousand:beforeUpdateCart', el);
  }
} 

// set all h2 urls to eu if location is eu
$(document).on('thousand:userLocationSet', (e, data)=>{
  if(data.isEUR){
    $('a[href="/products/bike-helmet-2"]').attr('href', '/products/bike-helmet-2-eu')
  }
});

if(user_loc){
  const locationDetails = {
    isUSA: false,
    isEUR: false,
    isASIA: false,
    country: ''
  }
  if (user_loc === "usa"){
    $('body').addClass('is-usa')
    locationDetails.isUSA = true;
  }  else {
    $('body').addClass('is-not-usa')
    $('body').addClass(`is-${ user_loc_country_handle }`)
  }
  if(user_loc === "eur"){
    $('body').addClass('is-eur')
    locationDetails.isEUR = true;
  }
  if(user_loc === "asia"){
    $('body').addClass('is-asia')
    locationDetails.isASIA = true;
  }
  locationDetails.country = user_loc_country_handle;
   $(document).trigger('thousand:userLocationSet', locationDetails);
}

// handle BIS

$('body').on('click', '.si_trigger', (e) => {
  e.preventDefault();
  let variantId = $('body').attr('data-variantid');
  SIPopover.hide();
  SIPopover.show({ variantId: variantId });
});

// 110 climate page
  
var Climate110Page = function(){
  var userIP;
  function init(){
    $.get("https://ipinfo.io/json", function (response) {
      userIP = response;
    }, "jsonp");

    var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if(iOS){
      $('.social-not-ios').hide();
      $('.social-ios').show();
    }

    var HeroScene = createScrollbarAnimateScene({
      targetEl: ".full-parallax__img",
      intersectEl: ".climate-section--enough",
      progressFunction: function(opts){
        return window.scrollY/($(opts.targetEl).outerHeight() + offset($(opts.targetEl)[0]).top)
      },
      animConfig: { y: '40%', ease:Linear.easeNone }
    });

    var ClimatePositiveScene = createContentAnimateScene({
      preAnimClass: 'willFadeInUp',
      targetEl: ".climate-section--going",
      animatedEls: ".climate-section--going h2, .climate-section--going p, .climate-section--going a",
      delayedEls: ".climate-section--going p, .climate-section--going a",
      animClass: 'animFadeInUp',
      config: { threshold: 0.5 }
    });

    var OffsetBarScene = createContentAnimateScene({
      targetEl: ".climate-bar__progress",
      animatedEls: ".climate-bar__progress",
      animClass: 'is--fullscale',
      config: { threshold: 1 }
    });

    var TheProblemScene = createContentAnimateScene({
      preAnimClass: 'willFadeInUp',
      targetEl: ".climate-section--problem",
      animatedEls: ".climate-section--problem h2, .climate-section--problem .preheader, .climate-section--problem .climate-copy",
      delayedEls: ".climate-section--problem h2, .climate-section--problem .climate-copy",
      animClass: 'animFadeInUp',
      config: { threshold: 0.5 }
    });

    var PathForwardScene = createContentAnimateScene({
      preAnimClass: 'willFadeInUp',
      targetEl: ".climate-section--forward",
      animatedEls: ".climate-section--forward h2, .climate-section--forward .preheader, .climate-section--forward .climate-copy",
      delayedEls: ".climate-section--forward h2, .climate-section--forward .climate-copy",
      animClass: 'animFadeInUp',
      config: { threshold: 0.5 }
    });

    var ComplicatedScene = createContentAnimateScene({
      preAnimClass: 'willFadeInUp',
      targetEl: ".climate-section--complicated",
      animatedEls: ".climate-section--complicated h2, .climate-section--complicated p, .climate-section--complicated a",
      delayedEls: ".climate-section--complicated p, .climate-section--complicated a",
      animClass: 'animFadeInUp',
      config: { threshold: 0.5 }
    });

    var FocusLockScene = createContentLockSceneWithDots({
      targetEl: ".climate-slide--focus",
      config: {threshold: [0], rootMargin: "0px 0px -100% 0px"}
    });

    var ThoughtLockScene = createContentLockSceneWithDots({
      targetEl: ".climate-slide--thought",
      config: {threshold: [0], rootMargin: "0px 0px -100% 0px"}
    });

    var ActionLockScene = createContentLockSceneWithDots({
      targetEl: ".climate-slide--action",
      config: {threshold: [0], rootMargin: "0px 0px -100% 0px"}
    });

    var StepLockScene = createContentLockSceneWithDots({
      targetEl: ".climate-slide--first-step",
      config: {threshold: [0], rootMargin: "0px 0px -100% 0px"}
    });    

    var ShowDotsScene = createToggleViewScene({
      targetEl: ".climate-scroller__dots",
      triggerEl: ".climate-section--means",
      config: {threshold: [0], rootMargin: "-50% 0px -50% 0px"}
    });

  }

  function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }

  function createScrollbarAnimateScene (opts){
    opts.config = opts.config || null;
    var parallaxTl = new TimelineLite({paused:true});
    var attachHandler = false;
    parallaxTl.to(opts.targetEl, opts.animConfig)
    var intersectionObserver = new IntersectionObserver(callback, opts.config);
    function callback(entries) {
      if (entries[0].intersectionRatio > 0){
        var enteredPoint = window.scrollY; // build off this
        if(attachHandler) return;
        attachHandler = true;
        $(window).on('scroll', function(e){ 
          parallaxTl.progress((opts.progressFunction(opts))).pause();
        });
      }
    }
    intersectionObserver.observe(document.querySelector(opts.intersectEl));   
  }

  function createContentAnimateScene(opts){
    opts.config = opts.config || null;
    var intersectionObserver = new IntersectionObserver(callback, opts.config);

    function callback(entries, self) {
      if (entries[0].intersectionRatio > 0) {
        $(opts.animatedEls).addClass(opts.animClass);
        $(opts.delayedEls).addClass('animDelayed');
      }
    }
    intersectionObserver.observe(document.querySelector(opts.targetEl));
    if(opts.preAnimClass){
      $(opts.animatedEls).addClass(opts.preAnimClass);
    }
  }

  function createContentLockScene(opts){
    opts.config = opts.config || null;
    var intersectionObserver = new IntersectionObserver(callback, opts.config);

    function callback(entries, self) {
      var firstEntry = entries[0];
      if ((firstEntry.intersectionRect.top === 0 && firstEntry.intersectionRect.bottom > 0)) {
        $(opts.targetEl).addClass('is--stuck')
      } else {
        $(opts.targetEl).removeClass('is--stuck')
      }
    }
    intersectionObserver.observe(document.querySelector(opts.targetEl));  
  }  

  function createContentLockSceneWithDots(opts){
    opts.config = opts.config || null;
    opts.triggerEl = opts.triggerEl || opts.targetEl;
    var intersectionObserver = new IntersectionObserver(callback, opts.config);

    function callback(entries, self) {
      var firstEntry = entries[0];
      if (firstEntry.isIntersecting) {
        $('.climate-scroller__dots .is--active').removeClass('is--active');
        $('.climate-scroller__dots span').eq($(opts.targetEl).index()).addClass('is--active');        
      }
    }
    intersectionObserver.observe(document.querySelector(opts.triggerEl));  
  }

  function createToggleViewScene(opts){
    opts.config = opts.config || null;
    opts.triggerEl = opts.triggerEl || opts.targetEl;
    var intersectionObserver = new IntersectionObserver(callback, opts.config);

    function callback(entries, self) {
      var firstEntry = entries[0];
      if (firstEntry.isIntersecting) {
        $(opts.targetEl).removeClass('hidden');
      } else {
        $(opts.targetEl).addClass('hidden')
      }
    }
    intersectionObserver.observe(document.querySelector(opts.triggerEl));  
  }  

  $('.loader-green').animate({ top: 0 }, 4000, function() {
    $('.climate-positive__page-loader').addClass('hidden');
    $('.climate-positive__page').fadeIn(500);
    setTimeout(function(){ init(); }, 1000  );
    
  });

  
  window.addEventListener('klaviyoForms', function(e) { 
     if (e.detail.type == 'submit') {
      	$('.vote__form').addClass('hidden');
      	$('.vote__thanks').removeClass('hidden').addClass('animFadeInUp');
      	postToSpreadsheet(e.detail.metaData.$email);
     }     
  });
  

  function postToSpreadsheet(email){
    var today = new Date()
    var date = today.toLocaleDateString('en-US')
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var formData = {
      email: email,
      vote: $('.vote__option.is--selected span').text()
    };
    var ajaxData;
    if(userIP){
      ajaxData = $.param(formData) + 
      '&date=' + date + ' ' + time + 
      '&city=' + userIP.city + 
      '&state=' + userIP.region + 
      '&postal=' + userIP.postal + 
      '&source=' + document.referrer + 
      '&' + window.location.search.replace("?", '')
    } else {
      ajaxData = $.param(formData) + 
      '&date=' + date + ' ' + time +       
      '&source=' + document.referrer + 
      '&' + window.location.search.replace("?", '')
    }
    return $.ajax({
      url: 'https://script.google.com/macros/s/AKfycbwtI78261ludbapgeEEiXdi5KvoME20GVz3y0V6/exec',
      type: 'get',
      data: ajaxData
    })
  }

  $('.climate-scroller__dots span').on('click', function(e){
    $('.climate-scroller__dots span').removeClass('is--active');
    $(this).addClass('is--active');
  })

  $('.play-button').click(function(e){
    e.preventDefault();
    var youtubeVid = '<iframe width="560" height="315" src="https://www.youtube.com/embed/StSoKDI-aB0?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    $('.video-wrap').html(youtubeVid);
    $('.video-wrap iframe').click();
  });

  $('.vote__option').on('click', function(){
    $('.vote__option').removeClass('is--selected')
    $(this).addClass('is--selected')
    $('.vote__error').addClass('hidden');
  })  
}

  
	Climate110Page();

const ShowMoreVariants = (()=> {
  const init = ()=> {
    const $trig = $('.show-variants-trigger');
    const hiddenClass = 'hidden-variant';
    const trigColumnClass = 'show-variants-column';
    $trig.click((e)=>{
      const $target = $(e.target);
      const targetID = e.target.dataset.id;
      $(`[data-parent-id=${targetID}]`).removeClass(hiddenClass);
      $target.parent(`.${trigColumnClass}`).remove();

    })
  }

  init();
});

ShowMoreVariants();

  	
	// Chapter
	var ChapterPage = (function(){
  
        // Hero Slider
        if($().slick === undefined){
          return;
        }
  
        let slickOpts = {
          vertical: true,
          verticalSwiping: true,
          // handle auto manually
          autoplay: false,
          autoplaySpeed: 3000,
          prevArrow: null,
          nextArrow: null,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                vertical: false,
                verticalSwiping: false
              }
            }
          ]
        };

        if (!$('.js-hero__slider').length) {
            return;
        }

        $('.js-hero__slider').slick(slickOpts);
        let slickInterval;

        // stop autplay when out of view
        const observer = new IntersectionObserver(entries => {
          let [{ isIntersecting }] = entries;
          if (isIntersecting) {
            // manual autoplay for reverse
            slickInterval = window.setInterval(function() {
              $('.js-hero__slider--forward').slick('slickNext');
              $('.js-hero__slider--reverse').slick('slickPrev');
            }, slickOpts.autoplaySpeed);
          } else {
            window.clearInterval(slickInterval);
          }
        })
        observer.observe(document.querySelector('.js-hero__slider'));

        // toggles
        $('.js-explore-helmet__trigger').click(function(){
            $(this).addClass('is--active').siblings().removeClass('is--active');
            $(this).parents('.explore-helmet').find('.copy-point').removeClass('is--active');
            $(this.dataset.target).addClass('is--active');
        });

        if($('.hidden-desktop').is(':visible')){
            $('.explore-helmet__trigger--4').click();
        }

        // Parallax
        document.querySelectorAll('[data-parallax-parent]').forEach(el => {
            new ScrollCSSVar({
                containerEl: el,
                intersectingEls: el.querySelectorAll('[data-parallax-target]').length ? el.querySelectorAll('[data-parallax-target]') : el,
                startPosition: el.dataset.parallaxStart || 'bottom'
            })
        });

        const fadeInObserver = new IntersectionObserver(entries => {
            let [{ isIntersecting, target }] = entries;
            if (isIntersecting) {
                $(target).addClass('is--in-view');
            }
        });

        document.querySelectorAll('[data-will-animate-in]').forEach(el => {
            fadeInObserver.observe(el);
        })


        function ScrollCSSVar({
              scrollOptions = { capture: false, passive: true },
              startPosition = 'bottom',
              containerEl = null,
              intersectingEls = null,
              callback = null
              } = {}){

                if(containerEl === null || intersectingEls === null){
                    throw('ScrollCSSVar is missing containerEl or intersectingEls');
                }

                let rootMargin = startPosition === 'top' ? '0px 0px -100% 0px' : '0px 0px 0px 0px';
                let containerVarVal = 0;

                callback = callback || onScroll;

                function onScroll() {
                    if(startPosition === 'bottom'){
                        containerVarVal = `${Math.round((window.innerHeight) - containerEl.getBoundingClientRect().y)}px`;
                    } else if(startPosition === 'top'){
                        containerVarVal = `${Math.max(-containerEl.getBoundingClientRect().y, 0)}px`;
                    }
                    containerEl.style.setProperty('--y', containerVarVal);      
                }

                const observer = new IntersectionObserver( entries => {
                    let [{ isIntersecting }] = entries;
                    if (isIntersecting) {
                        window.addEventListener('scroll', callback, scrollOptions);
                    } else {
                        window.removeEventListener('scroll', callback, scrollOptions);
                    }
                }, { rootMargin });


                if(!intersectingEls.length){
                    observer.observe(intersectingEls);
                } else {
                    intersectingEls.forEach(el => {
                    observer.observe(el);
                })
              }
          }
  
    })();

	$(document).ready(function () {
    var currentProduct = thousand.utils.getCurrentProductJSON();
    // Force variant selected event if only one variant
    if (currentProduct && currentProduct.variants.length === 1) {
      $(document).trigger('thousand:variant:selected', currentProduct.variants[0]);
    }
  });

  // Rebuy App
	const RebuyAppConfig = (()=> {

    const init = ()=> {      
      addClassesToSwatches();
    }    

    const addClassesToSwatches = ()=> {
      $('.rebuy-color-swatch').each((index, swatch)=> {
        const swatchClass = handleize($(swatch).find('label').attr('title'))
        $(swatch).addClass(`${swatchClass}-swatch`)
      })
    }
    document.addEventListener('rebuy.ready', function(event){ 
      init();
    });
    document.addEventListener('rebuy.add', function(event){ 
      console.log('rebuy.add event', event.detail); 
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: cartLoadedCallback
      });
    });     
  })();

  	// Add only current variant images to carousel
	var CurrentVariantProductCarousel = (()=> {
    let prevIndex = 0;
    let prevColorway = '';
    let firstLoad = true;

    const updateShareimgs = data =>{
      // update share images on variant change
      if(data.featured_image !== null){
        $('meta[property="og:image"]').get(0).setAttribute("content", data.featured_image.src);
        $('meta[property="og:image:secure_url"]').get(0).setAttribute("content", data.featured_image.src);
      }
    }

    const handleVariantChange = (e, data) => {      
      setVariantCarouselImages(data);
      updateShareimgs(data);
    }

    const removeVariantImages = carousel => carousel.remove($('*'))
    const selectCurrentImage = (carousel, index) => carousel.select(index, true, true);

    const setVariantCarouselImages = data => {
      const data_name = data.name.split("-")[0];
      let currentColorway = data.option1;
      if((data_name.indexOf('Traveler') >= 0) && data.option2 !== null){
        currentColorway = data.option1+' - '+data.option2;
      }
      // don't change carousel if only one product image TODO add missing color swatches to this conditional
      if($('.js-product-gallery').hasClass('single-image')){        
        return;
      }
      
      if (currentColorway === prevColorway) {
        return;
      }
      prevColorway = currentColorway;
      const allProductImages = thousand.pdpImages;
      const $carousel = $('.product_gallery');
      const $carouselNav = $('.product_gallery_nav');
      const carouselFlickity = $carousel.data('flickity');
      const carouselNavFlickity = $carouselNav.data('flickity');
      let currentProductImages = [];
      let currentGenericImages = [];
      let $currentProductImages;
      if(firstLoad || data_name.indexOf('Lock') >= 0){
        prevIndex = 0;
        if(firstLoad){
          firstLoad = false;
        }
      } else {
        prevIndex = $carouselNav.eq(0).find('.is-nav-selected').index();
      }
      
      
      $.each(allProductImages, function (idx, img) {     
        if (img.indexOf(currentColorway) > -1) {        
          // index 6 of split is 800px image. higher index is higher res
          currentProductImages.push($('<div class="gallery-cell"><img src="' + img.split('`~`')[6] + '" data-index="' + idx + '" /></div>'));
        }
        if (img.indexOf('generic') > -1) {
          // place at end of array
          currentGenericImages.push($('<div class="gallery-cell"><img src="' + img.split('`~`')[6] + '" data-index="' + idx + '" /></div>'));
        }
      });
      // create $ object 
      $currentProductImages = $(currentProductImages.concat(currentGenericImages))
        .map( (idx, img)=> (img.toArray()));

      if (data.name.toLowerCase().indexOf('glove') >= 0){
        currentColorway += ' Bike Gloves';
      }
      removeVariantImages(carouselFlickity)
      removeVariantImages(carouselNavFlickity)
      carouselFlickity.insert($currentProductImages);
      carouselNavFlickity.insert($currentProductImages.clone());
      selectCurrentImage(carouselFlickity, prevIndex);
      selectCurrentImage(carouselNavFlickity, prevIndex);
    }
    $(document).on('thousand:variant:selected', handleVariantChange);
	})();

  const stickyATC = (()=> {
    if(!$('body.product-2023').length || $('body.is--design-mode').length){
      return;
    }
    const options = {
      rootMargin: '0px 0px -100% 0px',
      root: document.body,
      threshold: 0
    }

    const observerTarget = document.querySelector('.js-purchase-details');
    const stickyItem = document.querySelector('.js-product-form--mobile-sticky');


    const callback = (entries, observer)=>{
      stickyItem.classList.add('hidden')
      if(entries[0].boundingClientRect.y <= 0){
      }
      if(entries[0].boundingClientRect.height + entries[0].boundingClientRect.top <= 0){
        stickyItem.classList.remove('hidden')
      }
    }

    var observer = new IntersectionObserver(callback, options);

    observer.observe(observerTarget);

    // require size select
    const $selectSize = $('.select-a-size');
    const hiddenClass = 'hidden';
    $selectSize.add('.swatch_options-2 label').on('click', (e)=>{
      e.preventDefault();
      $('.swatch-and-fit, .js-product-form--mobile-sticky .add_to_cart').removeClass(hiddenClass);
      $selectSize.addClass(hiddenClass)
    });
    
    // select correct size option based on variant selection
    $(document).on('thousand:variant:selected', function (e, data) {
      $(`.swatch-and-fit [data-value="${data.options[1]}"] label`).trigger('click', {"triggered": true});
    });

    //
    $('.js-product-form--mobile-sticky .swatch-element.size').click((e, data)=>{
      // prevent circular click triggering
      if(data?.triggered){
        return;
      }
      $(`.product-form--all [data-value="${$(e.currentTarget).data('value')}"]`).click();
    })

    // use fake atc button to trigger real one and scroll to top
    $('.js-product-form--mobile-sticky .add_to_cart').click(()=>{
      $('.purchase-details__buttons .add_to_cart').click();
      $('html,body').animate({scrollTop: $('body').offset().top});
    })

    // set fixed height on carousel on pdp desktop    
    $(document).on('thousand:carousel:selected', ()=>{      
      const secondImgHasLoaded = $('.js-product-gallery .gallery-cell:nth-child(2) img').height() > 0;
      if($(window).width() > 767 && secondImgHasLoaded){
        const $pdpSlider = $('.js-product-gallery .flickity-slider');
        $pdpSlider.css('height', $pdpSlider.height())
      }
    })

  })();
  
  $('.inter__bullet').click(function () {

    $('.inter__bullet').removeClass('is-active');
    $(this).toggleClass('is-active');
  });

